export default [
    {
        title: 'نظرسنجی',
        icon: 'Edit3Icon',
        children: [
            {
                title: 'نظرسنجی جدید',
                icon: 'Edit3Icon',
                route: 'Vote_Create',
                permission: 'votes.store',
            },
            {
                title: 'لیست نظرسنجی',
                icon: 'SendIcon',
                route: 'Vote_Index',
                permission: 'votes.index',
            },

            {
                title: 'شرکت در نظرسنجی',
                icon: 'ArchiveIcon',
                route: 'My_Votes',
                permission: 'my-votes.index',
            },

        ]
    }
]
